import {DestroyRef, inject, Injectable, signal} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormDebounceOperator} from '@frontend/shared';

@Injectable({
  providedIn: 'root',
})
export class FormStepValidationService {
  //TODO: move to form validation service
  private readonly destroyRef = inject(DestroyRef);

  attributeValueExists(
    control: FormControl<string>,
    isCheckingValidationSignal: ReturnType<typeof signal<boolean>>,
    apiCallFn: (name: string) => Observable<any>,
    handleCheckResultFn: (result: any) => void,
  ): void {
    FormDebounceOperator.create({
      control: control,
      apiCall: apiCallFn,
      options: {
        beforeRequest: () => isCheckingValidationSignal.set(true),
      },
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result) => handleCheckResultFn(result),
      });
  }

  updateControlErrors(control: AbstractControl, exists = false): void {
    if (!control.value?.trim()) {
      control.setErrors({required: true});
    } else if (exists) {
      control.setErrors({nameExists: true});
    } else {
      control.setErrors(null);
    }
  }

  setupControlTouchValidation(control: FormControl<string>): void {
    control.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (!control.touched) {
        control.markAsTouched();
      }
    });
  }
}
